"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDelivery = exports.searchPackages = exports.refreshCache = exports.markPackagesAsRead = exports.markPackageAsRead = exports.getPackage = exports.getFiles = exports.forwardPackage = exports.deletePackage = exports.createPackage = exports.checkPackageTransferStatus = void 0;
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
var config_1 = require("@app/shared/config");
/* Package API methods - BEGIN */
// Retrieve the transfer status information for a specific package, based on the provided package id
var checkPackageTransferStatus = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/packages/" + packageId + "/transfers")];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('Unable to retrieve transfer status for package');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.checkPackageTransferStatus = checkPackageTransferStatus;
// Create a new package, using the provided parameters
var createPackage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/packages",
                    method: 'post',
                    data: params
                })];
            case 1:
                response = _a.sent();
                if (response.data) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('unable to create package');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.createPackage = createPackage;
// Delete a package, based on the provided package id
var deletePackage = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/packages/" + packageId,
                    method: 'delete'
                })];
            case 1:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("unable to delete package " + packageId);
                }
                return [2 /*return*/];
        }
    });
}); };
exports.deletePackage = deletePackage;
// Forward an existing package, using the provided parameters
var forwardPackage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/packages/forward",
                    method: 'post',
                    data: params
                })];
            case 1:
                response = _a.sent();
                if (response.status === 201) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('unable to forward package');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.forwardPackage = forwardPackage;
// Retrieve the files for a specific package, based on the provided package id
var getFiles = function (packageId, type, path) { return __awaiter(void 0, void 0, void 0, function () {
    var requestData, response, responseData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestData = {
                    endpoint: type,
                    path: path ? path : '/'
                };
                return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/packages/" + packageId + "/files", requestData)];
            case 1:
                response = _a.sent();
                responseData = response.data;
                return [2 /*return*/, responseData.files];
        }
    });
}); };
exports.getFiles = getFiles;
// Retrieve a specific package, based on the provided package id
var getPackage = function (packageId, force, debug) {
    if (force === void 0) { force = false; }
    if (debug === void 0) { debug = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = {};
                    if (!!force) {
                        queryParams = {
                            force: 'true'
                        };
                    }
                    return [4 /*yield*/, axios_1.default({
                            url: config_1.Config.UI_SERVICES_URL + "/packages/" + packageId,
                            method: 'get',
                            headers: {
                                'X-DEBUG': !!debug
                            },
                            params: queryParams
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status === 200 && response.data) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw new Error('unable to retrieve package');
                    }
                    return [2 /*return*/];
            }
        });
    });
};
exports.getPackage = getPackage;
// Mark a specific package as "read", based on the provided package id
var markPackageAsRead = function (packageId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.put(config_1.Config.UI_SERVICES_URL + "/packages/" + packageId + "/read")];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.markPackageAsRead = markPackageAsRead;
// Mark multiple packages as "read", based on the provided package ids
var markPackagesAsRead = function (packageIds) { return __awaiter(void 0, void 0, void 0, function () {
    var requestData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestData = {
                    packageIds: packageIds
                };
                return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/packages/read", requestData)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.markPackagesAsRead = markPackagesAsRead;
/**
 * Refreshes the packages cache and user interactions for typeahead.
 * Should be called immediately after a new package is created or a new user is created
 */
var refreshCache = function (refreshType) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParam, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                queryParam = (refreshType) ? "?type=" + refreshType : '';
                return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/packages/refresh" + queryParam)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.refreshCache = refreshCache;
// Search for packages, using provided parameters
var searchPackages = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/packages/search",
                    method: 'post',
                    data: params
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.searchPackages = searchPackages;
// Validates the details of an external delivery
var validateDelivery = function (context) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    context: context
                };
                return [4 /*yield*/, axios_1.default({
                        url: config_1.Config.UI_SERVICES_URL + "/external-delivery/validate",
                        method: 'post',
                        data: data
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('unable to validate package delivery');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.validateDelivery = validateDelivery;
/* Package API methods - END */
